module.exports = __webpack_public_path__ + "img/NYYH.c1d68df7.png";